import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/legal/LegalLayout";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum — FlashWeb Agency" },
      { name: "description", content: "Note legali e informazioni societarie di FlashWeb Agency (FVT FuturaVision Technology GmbH), Zug — Svizzera." },
      { property: "og:title", content: "Impressum — FlashWeb Agency" },
      { property: "og:description", content: "Informazioni legali di FlashWeb Agency." },
      { property: "og:url", content: "https://www.flash-web.ch/impressum" },
      { name: "robots", content: "index, follow" },
    ],
    links: [{ rel: "canonical", href: "https://www.flash-web.ch/impressum" }],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" updated="7 luglio 2026">
      <h2>Editore del sito</h2>
      <ul>
        <li><strong>Ragione sociale:</strong> FVT FuturaVision Technology GmbH</li>
        <li><strong>Brand commerciale:</strong> FlashWeb Agency</li>
        <li><strong>Sede legale:</strong> Bareerstrasse 75, 6300 Zug, Svizzera</li>
        <li><strong>Sede operativa:</strong> Via Ai Prati 2, Bedano, Svizzera</li>
        <li><strong>N° registro di commercio:</strong> CH-170.4.022.832-9</li>
        <li><strong>Email:</strong> <a href="mailto:info@flash-web.ch">info@flash-web.ch</a></li>
        <li><strong>Sito web:</strong> <a href="https://www.flash-web.ch">www.flash-web.ch</a></li>
      </ul>

      <h2>Responsabile dei contenuti</h2>
      <p>
        Filippo Vaudano — <a href="mailto:info@flash-web.ch">info@flash-web.ch</a>
      </p>

      <h2>Disclaimer sui contenuti</h2>
      <p>
        FlashWeb cura con la massima attenzione i contenuti pubblicati sul sito. Tuttavia non fornisce
        alcuna garanzia in merito a completezza, accuratezza, attualità o affidabilità delle
        informazioni. Ogni responsabilità per danni derivanti dall'utilizzo o dal mancato utilizzo dei
        contenuti pubblicati è esclusa, nei limiti consentiti dalla legge.
      </p>
      <p>
        FlashWeb si riserva il diritto di modificare, integrare o rimuovere in qualsiasi momento parti
        del sito o l'intera offerta, senza preavviso, e di sospenderne temporaneamente o
        definitivamente la pubblicazione.
      </p>

      <h2>Disclaimer sui link esterni</h2>
      <p>
        Il sito può contenere link a risorse esterne gestite da soggetti terzi. FlashWeb non ha alcun
        controllo su tali siti e declina ogni responsabilità in merito a contenuti, disponibilità,
        privacy e trattamento dei dati effettuati dai relativi gestori. L'accesso a tali risorse avviene
        sotto la responsabilità esclusiva dell'utente.
      </p>

      <h2>Diritti d'autore</h2>
      <p>
        Tutti i contenuti pubblicati sul sito (testi, immagini, grafiche, marchi, logo, codice) sono
        protetti da diritto d'autore e appartengono a FlashWeb o ai rispettivi titolari. Qualsiasi
        riproduzione, distribuzione o utilizzo, anche parziale, richiede l'autorizzazione scritta
        preventiva.
      </p>

      <h2>Legge applicabile</h2>
      <p>
        Il presente sito è soggetto alla legge svizzera. Per qualsiasi controversia è competente il
        foro di Zug, fatti salvi i diritti inderogabili dei consumatori.
      </p>
    </LegalLayout>
  );
}
